export default {
  after: (field, [target]) => `${field} haruslah selepas ${target}.`,
  alpha: (field) => `${field} hanya boleh mengandungi aksara huruf.`,
  alpha_dash: (field) => `${field} boleh mengandungi aksara alfanumerik, tanda hubung, dan garis bawah.`,
  alpha_num: (field) => `${field} hanya boleh mengandungi aksara alfanumerik.`,
  before: (field, [target]) => `${field} haruslah sebelum ${target}.`,
  between: (field, [min, max]) => `${field} haruslah di antara ${min} dan ${max}.`,
  confirmed: (field, [confirmedField]) => `${field} tidak sepadan dengan ${confirmedField}.`,
  date_between: (field, [min, max]) => `${field} haruslah di antara ${min} dan ${max}.`,
  date_format: (field, [format]) => `${field} haruslah di dalam format ${format}.`,
  decimal: (field, [decimals] = ['*']) => `${field} harus berupa angka dan boleh mengandungi ${decimals === '*' ? '' : decimals} titik perpuluhan.`,
  digits: (field, [length]) => `${field} haruslah berupa ${length} digit angka.`,
  dimensions: (field, [width, height]) => `${field} berdimensi lebar ${width} pixel dan tinggi ${height} pixel.`,
  email: (field) => `${field} haruslah email yang sah.`,
  ext: (field) => `${field} haruslah fail yang sah.`,
  image: (field) => `${field} haruslah berbentuk imej gambar.`,
  in: (field) => `${field} haruslah nilai yang sah.`,
  ip: (field) => `${field} haruslah alamat ip yang sah.`,
  max: (field, [length]) => `${field} tidak boleh lebih daripada ${length} huruf.`,
  mimes: (field) => `${field} haruslah mempunyai jenis fail yang sah.`,
  min: (field, [length]) => `${field} minimum mengandungi ${length} huruf.`,
  not_in: (field) => `${field} haruslah nilai yang sah.`,
  numeric: (field) => `${field} haruslah berupa angka.`,
  regex: (field) => `Format ${field} adalah salah.`,
  required: (field) => `${field} perlu diisi.`,
  size: (field, [size]) => `${field} haruslah lebih kecil daripada ${size} KB.`,
  url: (field) => `${field} haruslah URL yang sah.`
}
